<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper';

import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isEffectivelyCollapsed: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const isDark = ref(document.body.classList.contains('dark'));

const toggleTheme = () => {
  const next = isDark.value ? 'light' : 'dark';
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, next);
  setColorTheme(window.matchMedia('(prefers-color-scheme: dark)').matches);
  isDark.value = next === 'dark';
};
</script>

<template>
  <Button
    v-tooltip.top-end="
      isDark
        ? t('COMMAND_BAR.COMMANDS.LIGHT_MODE')
        : t('COMMAND_BAR.COMMANDS.DARK_MODE')
    "
    :aria-label="
      isDark
        ? t('COMMAND_BAR.COMMANDS.LIGHT_MODE')
        : t('COMMAND_BAR.COMMANDS.DARK_MODE')
    "
    :icon="isDark ? 'i-lucide-sun' : 'i-lucide-moon'"
    color="slate"
    size="sm"
    class="dark:hover:!bg-n-slate-9/30"
    :class="
      isEffectivelyCollapsed
        ? '!size-11 !rounded-full !outline-none !text-n-slate-11'
        : '!h-8 !outline-n-weak !text-n-slate-11'
    "
    @click="toggleTheme"
  />
</template>
